import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import SectionDivider from '../../../components/SectionDivider.js';
import ContactInfo from './ContactInfo.js';
import TreeListDisplay from '../../../components/tree/TreeListDisplay.js';
import ItemList from './ItemList.js';
import TextContent from './TextContent.js';
import SocialLinks from './SocialLinks.js';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
  tick: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.common.tealish,
    marginRight: '0.5rem',
  },
}));

const ProfileInfoPanel = ({data}) => {
  const classes = useStyles();
  const registrations = [];

  if (data.ndis_registered) {
    registrations.push({id: 1, name: 'NDIS Registered'});
  }

  if (data.ndis_early_childhood_registered) {
    registrations.push({id: 2, name: 'NDIS Early Childhood Registered'});
  }

  const showContactInfo = (data.phone !== null || data.email !== null || data.website !== null);
  const showSocialLinks = (data.facebook_url !== null || data.twitter_url !== null || data.instagram_url !== null);

  return (
    <div className={classes.root}>
      {registrations && registrations.length ? (
        <React.Fragment>
          <SectionDivider />
          <ItemList title="NDIS Registrations" data={registrations} />
        </React.Fragment>
      ) : null}
      {showContactInfo ? (
        <React.Fragment>
          <SectionDivider />
          <ContactInfo data={data} />
        </React.Fragment>
      ) : null}
      {data.organisation_type === null ? null : (
        <React.Fragment>
          <SectionDivider />
          <TextContent title="Organisation type" data={data.organisation_type} capitalize/>
        </React.Fragment>
      )}
      {showSocialLinks ? (
        <React.Fragment>
          <SectionDivider />
          <SocialLinks data={data} />
        </React.Fragment>
      ) : null}
      {data.services && data.services.length ? (
        <React.Fragment>
          <SectionDivider />
          <TreeListDisplay title="Services available" data={data.services} />
        </React.Fragment>
      ) : null}
      {data.service_locations && data.service_locations.length ? (
        <React.Fragment>
          <SectionDivider />
          <TreeListDisplay title="Service locations" data={data.service_locations} />
        </React.Fragment>
      ) : null}
      {data.specialisations && data.specialisations.length ? (
        <React.Fragment>
          <SectionDivider />
          <ItemList title="Specialisations" data={data.specialisations} />
        </React.Fragment>
      ) : null}
      {data.age_groups && data.age_groups.length ? (
        <React.Fragment>
          <SectionDivider />
          <ItemList title="Age groups" data={data.age_groups} />
        </React.Fragment>
      ) : null}
      {data.access_methods && data.access_methods.length ? (
        <React.Fragment>
          <SectionDivider />
          <ItemList title="Access methods" data={data.access_methods} />
        </React.Fragment>
      ) : null}
      {data.good_to_know === null ? null : (
        <React.Fragment>
          <SectionDivider />
          <TextContent title="Good to know" data={data.good_to_know} />
        </React.Fragment>
      )}
    </div>
  );
};

ProfileInfoPanel.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProfileInfoPanel;
